import React, { useState, useEffect } from 'react';
import './Automacao.css';
import { ChakraProvider, useMediaQuery, Switch } from "@chakra-ui/react";
import Swal from 'sweetalert2';
import { MdMenu, MdAutorenew, MdThumbUp, MdComment, MdShare, MdBookmark, MdSmartButton, MdDashboard, MdEventAvailable, MdFace, MdForum, MdSettings, MdLocalActivity, MdKeyboardArrowLeft, MdArrowBack } from 'react-icons/md';
import { RiCopperCoinLine } from "react-icons/ri";
import { FaRobot } from "react-icons/fa";
import { useNavigate, useLocation } from 'react-router-dom';
import CustomDrawer from './CustomDrawer';
import translations from '../utils/translations.json';
import axios from 'axios';

const isValidUrl = (url) => {
    try {
        new URL(url);
    } catch (e) {
        return false;
    }
    return true;
};


let t;

const Automacao = () => {
    const userId = localStorage.getItem('userId');
    const userName = localStorage.getItem('username');
    const automacao = localStorage.getItem('automacao') === 'true';
    const navigate = useNavigate();
    const location = useLocation();
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'pt');
    const [activeTab, setActiveTab] = useState('posts');
    const [posts, setPosts] = useState([]);
    const [insights, setInsights] = useState([]);
    const [selectedPost, setSelectedPost] = useState(null);
    const [keywords, setKeywords] = useState([]);
    const [newKeyword, setNewKeyword] = useState('');
    const [automationMessage, setAutomationMessage] = useState('');
    const [automations, setAutomations] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [stats, setStats] = useState({
        totalMessages: 0,
        activeAutomations: 0,
        totalResponses: 0
    });
    const [isLoadingInitialData, setIsLoadingInitialData] = useState(true);
    const [allDataLoaded, setAllDataLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lastInsightsFetch, setLastInsightsFetch] = useState(null);
    const INSIGHTS_FETCH_COOLDOWN = 30000; // 30 segundos
    const itemsPerPage = 20;
    const [isMobile, setIsMobile] = useMediaQuery('(max-width: 768px)');
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    // Detectar se veio do GrowthPilot
    const params = new URLSearchParams(location.search);
    const fromGrowthPilot = params.get('from') === 'growthpilot';

    const getCreditsSum = () => {
        const creditsString = localStorage.getItem('credits');
        const credits = creditsString ? JSON.parse(creditsString) : { "GPT-3": 0, "GPT-4": 0 };
        return (credits["GPT-3"] || 0) + (credits["GPT-4"] || 0);
    };

    const [userCredits, setUserCredits] = useState(getCreditsSum());
   
    useEffect(() => {
        if (!automacao) {
            navigate('/main');
        }
    }, [automacao, navigate]);

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                setIsLoadingInitialData(true);
                await fetchPosts();
                await fetchAutomations();
            } catch (error) {
                console.error('Erro ao carregar dados iniciais:', error);
            } finally {
                setIsLoadingInitialData(false);
            }
        };

        if (automacao) {
            loadInitialData();
        }
    }, [automacao]);

    useEffect(() => {
        if (posts.length > 0) {
            console.log('Posts atualizados, buscando insights...');
            fetchInsights();
        }
    }, [posts]);

    if (!automacao) {
        return null;
    }

    t = (screen, key) => translations[language][screen][key];

    const UserProfileImage = ({ userId, perfilPicture }) => {
        const defaultAvatarUrl = `${process.env.REACT_APP_AVATAR_BASE_URL}${userId}${process.env.REACT_APP_AVATAR_PARAMS}`;
        const imageUrl = isValidUrl(perfilPicture) ? perfilPicture : defaultAvatarUrl;
        return (
            <div className="user-profile-image" style={{ backgroundImage: `url(${imageUrl})` }}></div>
        );
    };

    const handleHamburguerClick = () => {
        setIsOpen(true); // Abre o Drawer
    };

    const handleCloseDrawer = () => {
        setIsOpen(false); // Fecha o Drawer
    };

    const mainOpen = (language) => {
        if (fromGrowthPilot) {
            navigate(`/growthpilot?lang=${language}`);
        } else {
            navigate(`/main?lang=${language}`);
        }
    }

    const perfilOpen = () => {
        if (fromGrowthPilot) {
            navigate(`/viewuser?lang=${language}&from=growthpilot`);
        } else {
            navigate(`/viewuser?lang=${language}`);
        }
    }

    const analysisOpen = () => {
        if (fromGrowthPilot) {
            navigate(`/growthpilot?lang=${language}`);
        } else {
            navigate(`/analysis?lang=${language}`);
        }
    }

    const pciOpen = (language) => {
        if (fromGrowthPilot) {
            navigate(`/pci?from=growthpilot&lang=${language}`);
        } else {
            navigate(`/pci?lang=${language}`);
        }
    }

    const historyOpen = (language) => {
        if (fromGrowthPilot) {
            navigate(`/history?lang=${language}&from=growthpilot`);
        } else {
            navigate(`/history?lang=${language}`);
        }
    }

    const logout = (language) => {
        navigate(`/login?lang=${language}`);
    }



    const UserInfo = ({ userName, userId, userCredits }) => {
        const [isMobile] = useMediaQuery('(max-width: 768px)');

        const handleClick = () => {
            window.open('/viewuser', '_self');
        };

        return (
            <div className="user-info" onClick={handleClick} style={{
                position: 'absolute',
                top: '1px',
                right: '20px',
                padding: isMobile ? '5px 14px' : '8px 16px',
                backgroundColor: '#f8fafc',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                color: '#fff',
                fontSize: '17px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #e2e8f0',
                borderRadius: '80px',
                gap: isMobile ? '0px' : '12px'
            }}>
                <UserProfileImage userId={userId} perfilPicture={localStorage.getItem('perfil_picture')} />
                <div className="user-credits" style={{ color: '#4a5568', fontWeight: '500' }}>
                    {userName} | {userCredits} {t('pci', 'credits')}
                </div>
                <div className="userInfoMobile" style={{ color: '#4a5568', fontWeight: '500' }}>
                    {userCredits} {t('pci', 'credits')}
                </div>
            </div>
        );
    };

    const fetchPosts = async (page = 1) => {
        try {
            setLoading(true);
            const totenIndex = totenIdToIndex(localStorage.getItem('totenId'));
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/user-history`, {
                params: {
                    userId,
                    page,
                    itemsPerPage,
                    inputType: 'carousel',
                    totenIndex
                }
            });

            if (response.status === 200) {
                // Filtra apenas posts que têm instagramMediaIds
                const newData = response.data.filter(post => post.instagramMediaIds && post.instagramMediaIds.length > 0);
                console.log('Posts carregados da API:', newData);
                
                if (newData.length > 0) {
                    // Validar apenas os posts desta página
                    const validationResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/validate-instagram-posts`, {
                        params: {
                            userId,
                            totenIndex,
                            postIds: JSON.stringify(newData.flatMap(post => post.instagramMediaIds))
                        }
                    });

                    const validationResults = validationResponse.data.validationResults;
                    
                    if (page === 1) {
                        // Se for a primeira página, substitui completamente os posts
                        const formattedPosts = newData
                            .filter(post => post.instagramMediaIds.some(mediaId => validationResults[mediaId])) // Filtra apenas posts válidos
                            .map(post => {
                                const lastImageSet = post.azureImageUrls?.[post.azureImageUrls.length - 1];
                                const imageUrl = lastImageSet?.images?.find(url => url.includes("image01_")) || 'https://picsum.photos/400';
                                
                                return {
                                    id: post._id,
                                    imageUrl,
                                    caption: post.caption || 'Sem legenda',
                                    createdAt: post.sessionStart,
                                    instagramMediaIds: post.instagramMediaIds.filter(mediaId => validationResults[mediaId]), // Mantém apenas IDs válidos
                                    hasAutomation: false
                                };
                            });
                        setPosts(formattedPosts);
                    } else {
                        // Se for paginação, adiciona apenas posts novos
                        setPosts(prevPosts => {
                            const newPosts = newData
                                .filter(newPost => 
                                    !prevPosts.some(existingPost => existingPost.id === newPost._id) && 
                                    newPost.instagramMediaIds.some(mediaId => validationResults[mediaId]) // Filtra apenas posts válidos
                                )
                                .map(post => {
                                    const lastImageSet = post.azureImageUrls?.[post.azureImageUrls.length - 1];
                                    const imageUrl = lastImageSet?.images?.find(url => url.includes("image01_")) || 'https://picsum.photos/400';
                                    
                                    return {
                                        id: post._id,
                                        imageUrl,
                                        caption: post.caption || 'Sem legenda',
                                        createdAt: post.sessionStart,
                                        instagramMediaIds: post.instagramMediaIds.filter(mediaId => validationResults[mediaId]), // Mantém apenas IDs válidos
                                        hasAutomation: false
                                    };
                                });
                            return [...prevPosts, ...newPosts];
                        });
                    }
                }

                if (newData.length < itemsPerPage) {
                    setAllDataLoaded(true);
                }
            }
        } catch (error) {
            console.error('Erro ao buscar posts:', error);
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Erro ao carregar os posts. Por favor, tente novamente.',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        } finally {
            setLoading(false);
            setIsLoadingInitialData(false);
        }
    };

    const fetchAutomations = async () => {
        try {
            const totenIndex = totenIdToIndex(localStorage.getItem('totenId'));
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/${userId}/automations`, {
                params: {
                    totenIndex
                }
            });

            if (response.data.success) {
                setAutomations(response.data.automations);
                setStats(response.data.stats);

                // Atualizar o estado dos posts para refletir automações ativas
                setPosts(prevPosts => 
                    prevPosts.map(post => ({
                        ...post,
                        hasAutomation: response.data.automations.some(
                            automation => automation.contentId === post.id && automation.status === 'active'
                        ),
                        insights: post.insights || {} // Mantém os insights existentes
                    }))
                );
            }
        } catch (error) {
            console.error('Erro ao buscar automações:', error);
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Erro ao carregar as automações. Por favor, tente novamente.',
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        }
    };

    const fetchInsights = async () => {
        // Verifica se já buscamos insights recentemente
        if (lastInsightsFetch && Date.now() - lastInsightsFetch < INSIGHTS_FETCH_COOLDOWN) {
            console.log('Ignorando busca de insights - muito cedo para buscar novamente');
            return;
        }

        try {
            const totenIndex = totenIdToIndex(localStorage.getItem('totenId'));
            
            // Pegar todos os IDs de posts do Instagram do estado atual
            const mediaIds = posts
                .filter(post => post.instagramMediaIds && post.instagramMediaIds.length > 0)
                .flatMap(post => post.instagramMediaIds);

            if (mediaIds.length === 0) {
                console.log('Nenhum post com ID do Instagram encontrado');
                return;
            }

            console.log('Buscando insights para', mediaIds.length, 'posts');
            console.log('Media IDs:', mediaIds);
            
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/${userId}/insights`, {
                params: { 
                    totenIndex,
                    postIds: JSON.stringify(mediaIds)
                }
            });
    
            if (response.data.success) {
                const insightsData = response.data.insights;
                console.log('Insights recebidos:', insightsData);
                setInsights(insightsData);
                setLastInsightsFetch(Date.now());
    
                // Atualizar o estado dos posts para incluir insights
                setPosts(prevPosts => {
                    const updatedPosts = prevPosts.map(post => {
                        const postInsights = insightsData.find(insight => 
                            insight.postId === post.instagramMediaIds?.[0]
                        ) || {};
                        console.log(`Insights para post ${post.id}:`, postInsights);
                        return {
                            ...post,
                            insights: postInsights
                        };
                    });
                    return updatedPosts;
                });
            }
        } catch (error) {
            console.error('Erro ao buscar insights:', error);
        }
    };

    function totenIdToIndex(totenId) {
        const suffix = totenId.replace('perfil', '');
        const index = parseInt(suffix, 10) - 1;
        return index;
    }

    const handlePostSelect = async (post) => {
        // Buscar automação existente para este post (mesmo que esteja inativa)
        const existingAutomation = automations.find(a => a.contentId === post.id);

        console.log('existingAutomation', existingAutomation);

        const { value: formValues } = await Swal.fire({
            title: existingAutomation ? t('automation', 'editAutomation') : t('automation', 'setupAutomation'),
            html: `
                <div class="swal2-automation-form">
                    <div class="form-group">
                        <label>${t('automation', 'automationName')}:*</label>
                        <input 
                            id="automationName" 
                            class="swal2-input" 
                            placeholder="${t('automation', 'automationNamePlaceholder')}"
                            value="${existingAutomation ? existingAutomation.automationName || '' : ''}"
                        >
                    </div>
                    <div class="form-group">
                        <label>${t('automation', 'keywordsLabel')}:*</label>
                        <input 
                            id="keywords" 
                            class="swal2-input" 
                            placeholder="${t('automation', 'keywordsPlaceholder')}"
                            value="${existingAutomation ? existingAutomation.keywords.join(', ') : ''}"
                        >
                    </div>
                    <div class="form-group">
                        <label>${t('automation', 'publicReplyLabel')}:</label>
                        <input 
                            id="publicReply" 
                            class="swal2-input" 
                            placeholder="${t('automation', 'publicReplyPlaceholder')}"
                            value="${existingAutomation ? existingAutomation.publicResponse || existingAutomation.publicReply || '' : ''}"
                        >
                    </div>
                    <div class="form-group">
                        <label>${t('automation', 'directMessageLabel')}:*</label>
                        <textarea 
                            id="message" 
                            class="swal2-textarea" 
                            placeholder="${t('automation', 'directMessagePlaceholder')}"
                        >${existingAutomation ? existingAutomation.directMessage || existingAutomation.message || '' : ''}</textarea>
                    </div>
                    <div class="form-group">
                        <label>${t('automation', 'linkLabel')}:</label>
                        <input 
                            id="dmLink" 
                            class="swal2-input" 
                            placeholder="${t('automation', 'linkPlaceholder')}"
                            value="${existingAutomation ? existingAutomation.dmLink || '' : ''}"
                        >
                    </div>
                    <div class="form-group">
                        <label>${t('automation', 'buttonTextLabel')}:</label>
                        <input 
                            id="buttonText" 
                            class="swal2-input" 
                            placeholder="${t('automation', 'buttonTextPlaceholder')}"
                            value="${existingAutomation ? existingAutomation.buttonText || '' : ''}"
                        >
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: existingAutomation ? t('automation', 'update') : t('automation', 'save'),
            cancelButtonText: t('automation', 'cancel'),
            preConfirm: () => {
                const automationName = document.getElementById('automationName').value.trim();
                const keywords = document.getElementById('keywords').value.trim();
                const publicReply = document.getElementById('publicReply').value.trim();
                const message = document.getElementById('message').value.trim();
                const dmLink = document.getElementById('dmLink').value.trim();
                const buttonText = document.getElementById('buttonText').value.trim();

                // Validação dos campos obrigatórios
                if (!automationName) {
                    Swal.showValidationMessage(t('automation', 'automationNameRequired'));
                    return false;
                }

                if (!keywords) {
                    Swal.showValidationMessage(t('automation', 'keywordsRequired'));
                    return false;
                }

                if (!message) {
                    Swal.showValidationMessage(t('automation', 'directMessageRequired'));
                    return false;
                }

                return {
                    automationName,
                    keywords: keywords.split(',').map(k => k.trim()).filter(k => k),
                    publicResponse: publicReply,
                    directMessage: message,
                    dmLink,
                    buttonText
                };
            }
        });

        if (formValues) {
            try {
                const totenIndex = totenIdToIndex(localStorage.getItem('totenId'));
                const requestData = {
                    userId,
                    contentId: post.id,
                    postId: post.instagramMediaIds[0],
                    ...formValues,
                    totenIndex
                };

                // Se existir uma automação, incluir o ID para atualização
                if (existingAutomation) {
                    requestData._id = existingAutomation._id;
                }

                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/save-automation`, requestData);

                if (response.data.success) {
                    // Atualizar o estado local com a nova automação
                    if (existingAutomation) {
                        setAutomations(prevAutomations => 
                            prevAutomations.map(a => 
                                a._id === existingAutomation._id 
                                    ? { ...response.data.automation, status: 'active' }
                                    : a
                            )
                        );
                    } else {
                        setAutomations(prevAutomations => [...prevAutomations, response.data.automation]);
                    }

                    // Atualizar o estado do post
                    setPosts(prevPosts => 
                        prevPosts.map(p => 
                            p.id === post.id ? { ...p, hasAutomation: true } : p
                        )
                    );

                    // Atualizar as estatísticas
                    if (response.data.stats) {
                        setStats(response.data.stats);
                    }

                    Swal.fire({
                        icon: 'success',
                        title: t('automation', 'success'),
                        text: t('automation', 'automationSaved'),
                        customClass: {
                            popup: 'my-swal-special',
                            title: 'myCustomTitle'
                        }
                    });
                }
            } catch (error) {
                console.error('Erro ao salvar automação:', error);
                Swal.fire({
                    icon: 'error',
                    title: t('automation', 'error'),
                    text: t('automation', 'errorSaving'),
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    }
                });
            }
        }
    };

    const handleAddKeyword = (e) => {
        e.preventDefault();
        if (newKeyword.trim() && !keywords.includes(newKeyword.trim())) {
            setKeywords([...keywords, newKeyword.trim()]);
            setNewKeyword('');
        }
    };

    const handleRemoveKeyword = (keywordToRemove) => {
        setKeywords(keywords.filter(keyword => keyword !== keywordToRemove));
    };

    const handleAutomationClick = async (automation) => {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/users/automations/${automation._id}/status`,
                { active: automation.status !== 'active' }
            );

            if (response.data.success) {
                // Atualizar a lista de automações
                setAutomations(prevAutomations => 
                    prevAutomations.map(a => 
                        a._id === automation._id 
                            ? { ...a, status: a.status === 'active' ? 'inactive' : 'active' }
                            : a
                    )
                );

                // Atualizar a lista de posts
                setPosts(prevPosts => 
                    prevPosts.map(post => 
                        post.id === automation.contentId
                            ? { ...post, hasAutomation: automation.status !== 'active' }
                            : post
                    )
                );

                // Atualizar as estatísticas
                setStats(prevStats => ({
                    ...prevStats,
                    activeAutomations: prevStats.activeAutomations + (automation.status === 'active' ? -1 : 1)
                }));
            }
        } catch (error) {
            console.error('Erro ao atualizar status da automação:', error);
            Swal.fire({
                icon: 'error',
                title: t('automation', 'error'),
                text: t('automation', 'errorSaving'),
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        }
    };

    const handleViewMessages = async (post) => {
        try {
            const automation = automations.find(a => a.contentId === post.id);
            if (!automation) return;

            const totenIndex = totenIdToIndex(localStorage.getItem('totenId'));
            const dmResponse = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/users/${userId}/automations/${automation._id}/direct-messages`,
                {
                    params: { totenIndex }
                }
            );

            if (dmResponse.data.success && dmResponse.data.directMessages.length > 0) {
                const formattedMessages = dmResponse.data.directMessages.map(dm => ({
                    username: dm.username || '',
                    messageSent: dm.messageSent || '',
                    userResponses: (dm.userResponses || []).map(response => ({
                        text: response.text || '',
                        timestamp: new Date(response.timestamp).toLocaleString(),
                        isFromUser: response.isFromUser || false
                    })),
                    createdAt: new Date(dm.createdAt).toLocaleString()
                }));

                Swal.fire({
                    title: t('automation', 'directMessages'),
                    html: `
                        <div class="direct-messages-container">
                            ${formattedMessages.map(dm => `
                                <div class="direct-message">
                                    ${(dm.messageSent || dm.userResponses.length > 0) ? `
                                        <div class="dm-header">
                                            ${window.innerWidth <= 768 ? `
                                                <div style="display: flex; flex-direction: column; width: 100%;">
                                                    <div class="dm-field">
                                                        <span class="dm-icon">👤</span>
                                                        <span style="font-size: 14px;">${dm.username}</span>
                                                    </div>
                                                    <div class="dm-timestamp" style="font-size: 8px; color: #666; margin-top: 2px;">
                                                        <span class="dm-icon">🕒</span>
                                                        ${dm.createdAt}
                                                    </div>
                                                </div>
                                            ` : `
                                                <div class="dm-field">
                                                    <span class="dm-icon">👤</span>
                                                    <strong>${t('automation', 'userName')}: </strong> ${dm.username}
                                                </div>
                                                <div class="dm-field">
                                                    <span class="dm-icon">📅</span>
                                                    <strong>${t('automation', 'firstContactDate')}: </strong> ${dm.createdAt}
                                                </div>
                                            `}
                                        </div>
                                        <div class="dm-content">
                                            ${dm.messageSent ? `
                                                <div class="dm-field" style="${window.innerWidth <= 768 ? 'display: flex; flex-direction: column; align-items: flex-start; width: 100%;' : ''}">
                                                    <div style="display: flex; align-items: flex-start;">
                                                        <span class="dm-icon">📨</span>
                                                        ${window.innerWidth <= 768 ? '' : `<strong> ${t('automation', 'autoMessageSent')}: </strong>&nbsp;`}
                                                        <div class="dm-message">${dm.messageSent}</div>
                                                    </div>
                                                    ${window.innerWidth <= 768 ? `
                                                        <div class="dm-timestamp" style="font-size: 8px; color: #666; margin-top: 2px;">
                                                            <span class="dm-icon">🕒</span>
                                                            ${dm.createdAt}
                                                        </div>
                                                    ` : ''}
                                                </div>
                                            ` : ''}
                                            ${dm.userResponses.map(response => `
                                                ${response.text ? `
                                                    <div class="dm-field" style="${window.innerWidth <= 768 ? 'display: flex; flex-direction: column; align-items: flex-start; width: 100%;' : ''}">
                                                        <div style="display: flex; align-items: flex-start;">
                                                            <span class="dm-icon">${response.isFromUser ? '👤' : '📩'}</span>
                                                            ${window.innerWidth <= 768 ? '' : `<strong>${response.isFromUser ? t('automation', 'user') : t('automation', 'profile')}</strong>`}
                                                            <div class="dm-message">${response.text}</div>
                                                        </div>
                                                        <div class="dm-timestamp" style="font-size: 8px; color: #666; margin-top: 2px;">
                                                            <span class="dm-icon">🕒</span>
                                                            ${response.timestamp}
                                                        </div>
                                                    </div>
                                                ` : ''}
                                            `).join('')}
                                        </div>
                                        ${window.innerWidth > 768 ? `
                                            <div class="dm-footer">
                                                <div class="dm-field">
                                                    <span class="dm-icon">✅</span>
                                                    <strong>${t('automation', 'conversationStatus')}:</strong> ${dm.userResponses.length > 0 ? t('automation', 'inProgress') : t('automation', 'pending')}
                                                </div>
                                                <div class="dm-field">
                                                    <span class="dm-icon">📌</span>
                                                    <strong>${t('automation', 'origin')}:</strong> Comentário no post
                                                </div>
                                                <div class="dm-field">
                                                    <span class="dm-icon">📊</span>
                                                    <strong>${t('automation', 'entryMode')}:</strong> ${t('automation', 'automationActive')}
                                                </div>
                                                <div class="dm-field">
                                                    <span class="dm-icon">📁</span>
                                                    <strong>${t('automation', 'suggestedTags')}:</strong>
                                                    <div class="dm-tags">
                                                        <span class="dm-tag">Lead Instagram</span>
                                                        <span class="dm-tag">${t('automation', 'tagInterest')}</span>
                                                        <span class="dm-tag">${t('automation', 'tagAutomation')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ` : ''}
                                    ` : ''}
                                </div>
                            `).join('')}
                        </div>
                    `,
                    height: '80%',
                    width: '70%',
                    showCloseButton: false,
                    showConfirmButton: false,
                    customClass: {
                        popup: 'direct-messages-popup',
                        container: 'direct-messages-container'
                    }
                });
            } else {
                Swal.fire({
                    icon: 'info',
                    title: t('automation', 'noMessages'),
                    text: t('automation', 'noMessagesYet'),
                    customClass: {
                        popup: 'my-swal-special',
                        title: 'myCustomTitle'
                    }
                });
            }
        } catch (error) {
            console.error('Erro ao buscar mensagens diretas:', error);
            Swal.fire({
                icon: 'error',
                title: t('automation', 'error'),
                text: t('automation', 'errorLoadingMessages'),
                customClass: {
                    popup: 'my-swal-special',
                    title: 'myCustomTitle'
                }
            });
        }
    };

    // Sidebar igual ao GrowthPilot
    const renderSidebar = () => {
        if (!fromGrowthPilot) return null;
        return (
            <div className={`sidebar-fixed ${isMobile && isSidebarOpen ? 'active' : ''} ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                <div className="sidebar-header">
                    <div className="sidebar-logo">
                        <FaRobot size={22} />
                        <span className="menu-text">GrowthPilot</span>
                    </div>
                    <div className="sidebar-toggle-btn" onClick={() => setIsSidebarCollapsed(prev => !prev)}>
                        <MdKeyboardArrowLeft size={24} />
                    </div>
                </div>
                <div className="sidebar-menu">
                    <div className="menu-item" onClick={() => navigate(`/growthpilot?lang=${language}`)}>
                        <MdEventAvailable size={20} />
                        <span className="menu-text">Content Planner</span>
                    </div>
                    <div className="menu-item" onClick={() => navigate(`/pci?from=growthpilot&lang=${language}`)}>
                        <RiCopperCoinLine size={20} />
                        <span className="menu-text">PCI</span>
                    </div>
                    <div className="menu-item" onClick={() => navigate(`/viewuser?lang=${language}&from=growthpilot`)}>
                        <MdFace size={20} />
                        <span className="menu-text">Avatares</span>
                    </div>
                    {/* <div className="menu-item" onClick={() => navigate(`/history?lang=${language}&from=growthpilot`)}>
                        <MdForum size={20} />
                        <span className="menu-text">Histórico de Conteúdo</span>
                    </div> */}
                    <div className="menu-item active">
                        <MdAutorenew size={20} />
                        <span className="menu-text">Automação</span>
                    </div>
                    <div className="menu-item" onClick={() => navigate(`/growthpilot/analytics?lang=${language}`)}>
                        <MdDashboard size={20} />
                        <span className="menu-text">Analytics</span>
                    </div>
                    <div className="menu-item" onClick={() => navigate(`/growthpilot/config?lang=${language}`)}>
                        <MdSettings size={20} />
                        <span className="menu-text">Configurações</span>
                    </div>
                    <div className="menu-item" onClick={() => navigate(`/main?lang=${language}`)}>
                        <MdArrowBack size={20} />
                        <span className="menu-text">Voltar para o PostSucesso</span>
                    </div>
                </div>
                <div className="sidebar-footer">
                    <div className="support-button">
                        <MdLocalActivity size={22} />
                        <span className="menu-text">Suporte</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {renderSidebar()}
            <div className={`automation${fromGrowthPilot ? ' growthpilot-font' : ''}${isSidebarCollapsed ? ' sidebar-collapsed' : ''}`}>
                <ChakraProvider>
                    <CustomDrawer
                        isOpen={isOpen}
                        onClose={handleCloseDrawer}
                        onContentOpen={() => mainOpen(language)}
                        onPerfilOpen={() => perfilOpen(language)}
                        onAnalysisOpen={() => analysisOpen(language)}
                        onLogout={() => logout(language)}
                        onHistoryOpen={() => historyOpen(language)}
                        onPCI={() => pciOpen(language)}
                        t={t}
                        language={language}
                        setLanguage={setLanguage}
                    />
                </ChakraProvider>
                {fromGrowthPilot ? (
                    <div className="growthpilot-topbar">
                        <div className="growthpilot-title-container">
                            <div className="growthpilot-title">
                                <MdDashboard size={24} className="title-icon" />
                                GrowthPilot
                            </div>
                        </div>
                        <div className="topbar-actions">
                            <div className="growthpilot-user growthpilot-user-large">
                                <UserProfileImage userId={userId} perfilPicture={localStorage.getItem('perfil_picture')} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="header">
                        <UserInfo userName={userName} userId={userId} userCredits={userCredits} />
                        <div className="image-container_automacao">
                            <MdMenu className="menu-icon"
                                onClick={handleHamburguerClick} />
                        </div>
                        <div className="image-container_automacao_02">
                            <img
                                src="https://blob01instasuccess.blob.core.windows.net/fotos-logos/postSucessoLogo.png"
                                alt="Logo"
                                className="logo"
                            />
                        </div>
                    </div>
                )}

                <div className={`automation-container${fromGrowthPilot ? ' growthpilot-font' : ''}`}>
                    <div className="tabs-container">
                        <div className="tab-list">
                            <div
                                className={`tabAuto ${activeTab === 'posts' ? 'active' : ''}${fromGrowthPilot ? ' growthpilot-font' : ''}`}
                                onClick={() => setActiveTab('posts')}
                            >
                                {t('automation', 'posts')}
                            </div>
                            <div
                                className={`tabAuto ${activeTab === 'automations' ? 'active' : ''}${fromGrowthPilot ? ' growthpilot-font' : ''}`}
                                onClick={() => setActiveTab('automations')}
                            >
                                {t('automation', 'automations')}
                            </div>
                        </div>
                    </div>

                    {activeTab === 'posts' ? (
                        <div className="posts-container">
                            <div className="post-selection-grid">
                                {isLoadingInitialData ? (
                                    <div className="spinner"></div>
                                ) : posts.length === 0 ? (
                                    <div className="no-data-placeholder">
                                        <span>{t('automation', 'noPostsFound')}</span>
                                    </div>
                                ) : (
                                    posts.map(post => (
                                        <div
                                            key={post.id}
                                            className="post-card"
                                            onClick={() => handlePostSelect(post)}
                                            title={t('automation', 'clickToSetup')}
                                        >
                                            <div className="click-indicator">{t('automation', 'clickToSetup')}</div>
                                            <img src={post.imageUrl} alt={post.caption} className="post-image" />
                                            <div className="post-info">
                                                <div className="post-footer">
                                                    <div className="post-stats">
                                                        <span className="stat-item"><MdThumbUp size={18} /> <span className="stat-number">{post.insights?.likes || 0}</span></span>
                                                        <span className="stat-item"><MdComment size={18} /> <span className="stat-number">{post.insights?.comments || 0}</span></span>
                                                        <span className="stat-item"><MdShare size={18} /> <span className="stat-number">{post.insights?.shares || 0}</span></span>
                                                        <span className="stat-item"><MdBookmark size={18} /> <span className="stat-number">{post.insights?.saved || 0}</span></span>
                                                    </div>
                                                    <div className="post-actions">
                                                        {post.hasAutomation !== undefined && (
                                                            <>
                                                                <div className={`status-badge ${post.hasAutomation ? 'active' : 'inactive'}`}>
                                                                    {post.hasAutomation ? t('automation', 'active') : t('automation', 'inactive')}
                                                                </div>
                                                                {post.hasAutomation && localStorage.getItem('isAdmin') === 'true' && (
                                                                    <button 
                                                                        className="view-messages-btn"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleViewMessages(post);
                                                                        }}
                                                                        title={t('automation', 'viewMessages')}
                                                                    >
                                                                        <MdSmartButton size={18} />
                                                                    </button>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="automation-stats">
                                <div className="stat-card">
                                    <div className="stat-value">{stats.totalMessages}</div>
                                    <div className="stat-label">{t('automation', 'messagesSent')}</div>
                                </div>
                                <div className="stat-card">
                                    <div className="stat-value">{stats.activeAutomations}</div>
                                    <div className="stat-label">{t('automation', 'activeAutomations')}</div>
                                </div>
                                <div className="stat-card">
                                    <div className="stat-value">{stats.totalResponses}</div>
                                    <div className="stat-label">{t('automation', 'responsesReceived')}</div>
                                </div>
                            </div>
                            <div className="automations-list">
                                {[...automations].reverse().map(automation => (
                                    <div 
                                        key={automation.id} 
                                        className="automation-card"
                                        style={{ cursor: 'default' }}
                                    >
                                        <div className="automation-header">
                                            <h3>{automation.automationName || automation.postTitle}</h3>
                                            <div className="status-controls">
                                                <ChakraProvider>
                                                    <Switch
                                                        isChecked={automation.status === 'active'}
                                                        onChange={() => handleAutomationClick(automation)}
                                                        colorScheme="green"
                                                        size="lg"
                                                    />
                                                </ChakraProvider>
                                                <div className={`status-badge ${automation.status === 'active' ? 'active' : 'inactive'}`}>
                                                    {automation.status === 'active' ? t('automation', 'active') : t('automation', 'inactive')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="automation-content">
                                            <div className="keywords-section">
                                                <strong>{t('automation', 'keywords')}:</strong>
                                                <div className="keyword-tags">
                                                    {automation.keywords.map(keyword => (
                                                        <div key={keyword} className="keyword-tag">
                                                            {keyword}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="message-section">
                                                <strong>{t('automation', 'publicReply')}:</strong>
                                                <p>{automation.publicReply}</p>
                                                <strong>{t('automation', 'directMessage')}:</strong>
                                                <p>{automation.message}</p>
                                                <strong>{t('automation', 'button')}:</strong>
                                                <p>{automation.buttonText}</p>
                                                <strong>{t('automation', 'link')}:</strong>
                                                <p className="dm-link">{automation.dmLink}</p>
                                            </div>
                                            <div className="stats-section">
                                                <div>{t('automation', 'messagesSentCount')}: {automation.messagesSent}</div>
                                                <div>{t('automation', 'responsesReceivedCount')}: {automation.responsesReceived}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default Automacao;